import { EmptySection } from '../components/Card.jsx';

/* TODO: account, plan, main number, call recording, outbound caller ID.
   Billing stays in WHMCS — link out, never duplicate it.

   Deliberately absent: which PBX platform serves this customer. */
export default function Settings() {
  return (
    <EmptySection
      title="Settings"
      body="Your account, plan, phone numbers and call-recording settings will appear here. Billing stays in your WHMCS account."
    />
  );
}
